module.exports = __webpack_public_path__ + "img/logo.25a58f8c.png";